export default "__VITE_ASSET__DKhgYzmH__"